module.exports = __webpack_public_path__ + "static/media/MonkeyKing_0.22d88ab6.jpg";